import React from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
const Admin = () => {
    
    return (
        <div>
            <Navbar />

            <div>
                <button>اضافه کردن محصول جدید</button>
                <button>پاک کردن محصول </button>
            </div>

            <Footer />
        </div>
    );
};

export default Admin;